'use strict';

angular.module('imagetrend.components')
    .directive('hlpPostalCode', ['Format', 'Validation', 'FIPSLookup', '$timeout', '$modal', function (Format, Validation, FIPSLookup, $timeout, $modal) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question:'=?',
                city: '=',
                county: '=',
                state: '=',
                validation: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                size: '@?',
                type: '@?',
                maxLength: '@?',
                modal: '@?',
                placeholder: '@?',

                //disabled
                isDisabled: '=?',

                //required
                isRequired: '=?',
                showRequired: '=?',
                requiredText: '@?',

                //label
                showLabel: '@?',
                topLabel: '=?',
                showColon: '=?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                pdf: '=?'
            },
            replace: true,
            transclude: true,
            require: 'ngModel',
            templateUrl: 'templates/postal-code/postal-code.html',
            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                $scope.validate = function () {
                    if (!$scope.requiredText) { $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || $scope.name)) }

                    if ($scope.innerForm !== undefined) {
                        if ($scope.validation) {
                            Validation.validateQuestion($scope.innerForm.input, $scope.validation, $scope.ngModel);
                        }
                        if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                            $scope.question.answer.invalid = !isEmpty($scope.innerForm.input.$error);
                        }
                    }
                }
                var validationTimeout = $timeout($scope.validate(), 0);
                $scope.$on('$destroy', function () {
                    $timeout.cancel(validationTimeout);
                });
            }],
            link: function (scope, elem, attrs, ctrl) {

                scope.timeouts = [];

                //attributes
                if (!attrs.name) { attrs.name = 'zip'; }
                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.size) { attrs.size = '35'; }
                if (!attrs.type) { attrs.type = 'text' }
                if (!attrs.modal) { attrs.modal = false; } else { if (attrs.modal == 'true') { attrs.modal = true; } else { attrs.modal = false; } }

                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }

                scope.lookupZip = function() {
                    scope.postalSearching = true;
                    scope.ngModel = scope.ngModel || "";
                    FIPSLookup.getByPostalCode(scope.ngModel).then(function (data) {
                        if (data != null) {
                            scope.failMessage = "";
                            if (data.length == 1) {
                                // Found a single match, just set values
                                var result = data[0];
                                scope.city = result.city_name;
                                scope.county = result.county_name;
                                scope.state = result.region_id;
                            }
                            else {
                                // Found 0 or multiple matches, open up a modal to let them pick the one they want
                                $modal.open({
                                    animation: true,
                                    templateUrl: 'templates/postal-code/postal-code-modal.html',
                                    controller: 'PostalCodeModalController',
                                    resolve: {
                                        postalCode: function() {
                                            return scope.ngModel;
                                        },
                                        addresses: function () {
                                            return data;
                                        }
                                    }
                                }).result.then(function (result) {
                                    if (result != null) {
                                        scope.city = result.city_name;
                                        scope.county = result.county_name;
                                        scope.state = result.region_id;
                                        scope.ngModel = result.postal_code;
                                    }
                                });
                            }
                        }
                        else {
                            scope.failMessage = "Could not find information for this postal code.";
                        }
                            
                        scope.postalSearching = false;
                    });
                }
                
                // see if this needs to be wrapped in a $timeout
                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (scope.ngModel.length == 5) {
                        scope.lookupZip();
                    }
                    if (scope.validation) {
                        Validation.validateQuestion(scope.innerForm.input, scope.validation, scope.ngModel);
                    }
                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                        scope.question.answer.invalid = !isEmpty(scope.innerForm.input.$error);
                    }
                }
                ctrl.$viewChangeListeners.push(function () {
                    scope.$eval(attrs.ngChange);
                });

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    scope.timeouts.forEach(function (timer) {
                        $timeout.cancel(timer);
                    });
                });
            }
        };
    }])
;